import {
  doc,
  setDoc,
  getDoc
} from "firebase/firestore";
import { firestore} from "../firebase-config";

export const saveUserToFirestore = async (providerData) => {
  try {
    await setDoc(doc(firestore, "users", providerData.uid), providerData, { merge: true });
    // console.log("User saved successfully:", providerData);
  } catch (error) {
    console.error("Error saving user to Firestore:", error);
  }
};


export const getUserFromFirestore = async (userId) => {
  try {
    const userRef = doc(firestore, "users", userId); // Assuming users are stored under 'users' collection
    const userDoc = await getDoc(userRef);
    if (userDoc.exists()) {
      return { id: userDoc.id, ...userDoc.data() }; // Return user data
    } else {
      console.log("No such user!");
      return null; // User not found
    }
  } catch (error) {
    console.error("Error fetching user data:", error);
    throw error; // Re-throw error for handling
  }
};
















